<template>
  <a-card title="目的地" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="hotId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      requestType="get"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入目的地名称" @search="onSearch" style="max-width: 400px;"/>
        <a-button style="margin-left: 10px" type="primary" @click="createDesEvent(0)">添加目的地</a-button>
        <span class="herder-set">
        <span>开启自动目的地推荐  <a @click="openDesDialog">设置</a></span>
      </span>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="createDesEvent(data.record.hotId)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="是否要删除当前目的地？"
          @confirm="deleteEvent(data.record.hotId)">
          <a-icon slot="icon" type="close-circle" style="color: red"/>
          <a>删除</a>
        </a-popconfirm>
      </div>
    </search-page-view>
    <a-modal title="目的地设置" :visible="dialogVisible" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="是否显示">
          <a-radio-group name="radioGroup" v-model="ruleForm.shopDestinationStatus">
            <a-radio :value="1">显示</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="推荐方式">
          <a-radio-group name="radioGroup" v-model="ruleForm.shopDestinationType">
            <a-radio :value="0">仅人工</a-radio>
            <a-radio :value="1">仅自动</a-radio>
            <a-radio :value="2">人工+自动</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button style="margin-left: 10px;" @click="dialogVisible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'Destination',
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        shopDestinationStatus: 0,//店铺目的地 0关闭 1显示
        shopDestinationType: 0//店铺目的地推荐方式 0仅人工 1仅自动 2人工+自动
      },
      queryParams: {
        hotDestinationName: '' //热门目的地名称
      },
      loadPromise: params => this.getRequest(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'hotId'
        },
        {
          title: '目的地名称',
          dataIndex: 'hotDestinationName'
        },
        {
          title: '关联目的地',
          dataIndex: 'containCity'
        },
        {
          title: '是否推荐',
          dataIndex: 'hotIsHotPushStr'
        },
        {
          title: '状态',
          dataIndex: 'hotStatus'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '130px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dialogVisible: false
    }
  },
  mounted() {
  },
  activated() {
    this.getLogUtils().logWithTag('目的地activated')
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    onSearch(value) {
      this.queryParams.hotDestinationName = value ? value : ''
      this.$refs.table.refresh(true)
    },
    getRequest(parameter) {
      return this.getHttpServices().getUserService().get('user/shopDestination/getShopDestinationList', parameter)
    },
    // 删除
    deleteEvent(hotId) {
      this.getLogUtils().logWithTag('deleteEvent', hotId)
      this.getHttpServices().getUserService().post('user/shopDestination/processShopDestination?hotId=' + hotId, '')
        .then(res => {
          this.getLogUtils().logWithTag('==deleteEvent==', res)
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 新增内容
    createDesEvent(hotId) {
      this.$router.push({
        name: 'AddDestination',
        query: {
          hotId: hotId
        }
      })
    },
    openDesDialog() {
      this.dialogVisible = true
      this.getDestinationInfo()
    },
    getDestinationInfo() {
      this.getHttpServices().getUserService().get('user/shopDestination/getShopDestinationInfo')
        .then(res => {
          this.getLogUtils().logWithTag('==getDestinationInfo==', res)
          this.ruleForm = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getUserService().post('user/shopDestination/editShopDestinationInfo', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('目的地设置成功')
        this.dialogVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style scoped lang="less">
.herder-set {
  text-align: right;
  float: right;

  a {
    padding-left: 10px;
  }
}
</style>